<!-- https://8es9hr.axshare.com/#g=1&p=%E7%A4%BE%E5%93%A1%E8%BD%89%E5%B8%B3%E5%82%99%E5%BF%98%E9%8C%84 -->
<!-- 社員轉帳備忘錄 -->
<template>
    <div class="row" v-if="$route.meta.subListKeepAlive">
        <div class="col-12">
            <div class="mb10">
                <el-button
                    type="primary"
                    plain
                    @click="go('cabinet_edit')"
                    v-if="$route.params.id != undefined"
                >回社員首頁</el-button>
                <el-button
                    type="danger"
                    plain
                    @click="go('cabinet_search')"
                    v-if="$route.params.id != undefined"
                >搜尋其他社員</el-button>
            </div>
            <div class="col-block">
                <div class="block-header has-border">
                    <h3 v-if="dataArr != null">
                        <strong>
                            {{ dataArr.account }} {{ dataArr.idNumber }}
                            {{ dataArr.name }}
                        </strong>
                        &nbsp;
                    </h3>
                    <!-- 只有社員可以搜尋其他社員 -->
                    <h3>
                        <strong>社員轉帳備忘錄</strong>
                    </h3>
                    <!-- !!!!! 先寫在這 之後寫在workbench slot 加上所選取的內容query 過去下一頁 !!!!!  -->
                    <el-button type="primary" class="ml10" plain @click="transferVoucher">開立轉帳傳票</el-button>
                </div>
                <div class="block-content">
                    <!-- list -->
                    <!-- 缺少 開立轉帳傳票 filter 傳票開立狀態 -->
                    <workbench
                        api="memberTransferMemo"
                        :columns="columns"
                        :toolbar="toolbar"
                        :filter="filter"
                        @editData="editData"
                        @addData="editData"
                        class="mt10"
                        @enumData="getEnumData"
                        :query="query"
                        ref="workbench"
                    >
                        <template slot="button">
                            <span class="ml10 mr10">查詢日期區間</span>
                            <div class="date">
                                <input type="text" class="min_go_date startDate" placeholder="選擇日期" />
                                <span class="el-input__prefix">
                                    <i class="el-icon-date"></i>
                                </span>
                            </div>~
                            <div class="date">
                                <input type="text" class="min_go_date endDate" placeholder="選擇日期" />
                                <span class="el-input__prefix">
                                    <i class="el-icon-date"></i>
                                </span>
                            </div>
                            <el-button type="primary" plain class="ml10" @click="search">查詢</el-button>
                            <div class="filter-group">
                                <span class="filter-label ml10">傳票開立狀態</span>
                                <el-select v-model="voucherStatusSelect" placeholder="請選擇類型">
                                    <el-option
                                        v-for="item of voucherStatus"
                                        :label="item.label"
                                        :value="item.value"
                                        :key="item.value"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="filter-group"  v-if="$route.params.id == undefined">
                                <span class="filter-label ml10">社員帳號</span>
                                <el-input
                                    v-model="chooseMember.showLabel"
                                    placeholder="請選擇社員"
                                    @focus="openMember"
                                    style="width: 200px;"
                                >
                                <el-button slot="append" icon="el-icon-close" @click="cleanMember"></el-button>
                            </el-input>
                            </div>
<!-- 
                         <div class="filter-group" v-if="$route.params.id == undefined">
                                <span class="filter-label ml10">社員選擇</span>
                                <el-input
                                    style="width: 200px;"
                                    v-model="chooseMember.showLabel"
                                    placeholder="請選擇社員"
                                    @focus="openMember()"
                                    :clearable="false"
                                    @clear="clear(chooseMember[item.key], item.key)"
                                >
                                <el-button slot="append" icon="el-icon-close" @click="cleanMember"></el-button>
                            </el-input>
                            
                            </div> -->   
                        </template>
                    </workbench>

                    <el-dialog
                        :visible.sync="dialogAddItem"
                        :append-to-body="true"
                        :close-on-click-modal="false"
                        width="370px"
                        slot="show"
                        @close="closeEdit"
                    >
                        <ListForm
                            api
                            :id="id"
                            labelPosition="top"
                            formTitle="社員轉帳備忘錄"
                            ref="listForm"
                            :recordToEdit="currentEdit"
                            :formType="formType"
                        >
                            <div slot="footer">
                                <el-button @click="closeEdit">取消</el-button>
                                <el-button type="primary" @click="saveData">確定</el-button>
                            </div>
                        </ListForm>
                    </el-dialog>

                    <!-- 建立新記事 -->
                    <el-dialog
                        title="選擇社員"
                        :visible.sync="dialogMember"
                        :modal-append-to-body="false"
                        :append-to-body="true"
                        width="660px"
                    >
                        <workbench
                            api="member"
                            :columns="chooseMemberColumns"
                            :toolbar="memberChooseToolbar"
                            @editData="
                (id, row) => {
                  clickMember(id, row, form, 'prop', 'currentEdit');
                }
              "
                        ></workbench>
                    </el-dialog>
                </div>
            </div>
        </div>
    </div>
    <router-view v-else></router-view>
</template>
<script>
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";
import ListForm from "@/components/ListForm.vue";

export default {
    name: "cabinet_transfer",
    components: { Workbench, ListForm },
    data() {
        return {
            id: this.$route.params.id,
            query: { memberId: this.$route.params.id },
            // 選擇社員
            chooseMember: {},
            dialogMember: false,
            dataArr: {},
            searchDate: [],
            voucherStatusSelect: "",
            currentEdit: { transferAmount: 0 },
            dialogAddItemOld: false,
            dialogAddItem: false,
            formType: [
                {
                    label: "社員帳號",
                    key: "memberId",
                    type: "chooseMember",
                    returnKey: "id",
                    vif: this.$route.params.id == null
                },
                {
                    label: "匯款日期",
                    key: "transferDate",
                    type: "date"
                },
                {
                    label: "匯到哪個銀行帳戶",
                    key: "coopBankId",
                    type: "select",
                    options: []
                },
                {
                    label: "匯款帳號後五碼",
                    key: "transferAccountNumber",
                    type: "input"
                },
                {
                    label: "匯款金額",
                    key: "transferAmount",
                    type: "input",
                    addcomma: true
                },
                {
                    label: "用途說明",
                    key: "note",
                    type: "textarea"
                }
            ],
            voucherStatus: [
                {
                    label: "全部",
                    value: ""
                },
                {
                    label: "已處理",
                    value: 1
                },
                {
                    label: "未處理",
                    value: 0
                }
            ],
            toolbar: {
                select: false,
                checkboxDisabled: true
            },
            memberChooseToolbar: {
                addable: false,
                removeable: false,
                select: false,
                pageQuery: false
            },
            chooseMemberColumns: [
                {
                    label: "社員帳號",
                    prop: "account"
                },
                {
                    label: "社員名稱",
                    prop: "name"
                },
                {
                    label: "社員類型",
                    prop: "typeKey",
                    renderFunction(h, scope, enumData) {
                        return h(
                            "div",
                            enumData.memberTypeKey[scope.row.typeKey]
                        );
                    }
                },
                {
                    label: "群組代號",
                    prop: "memberGroupId",
                    renderFunction(h, scope, enumData) {
                        let result = "";
                        enumData.memberGroup.forEach(element => {
                            if (scope.row.memberGroupId == element.id) {
                                result = element.name;
                            }
                        });
                        return h("div", result);
                    }
                },
                
            ],
            filter: {},
            columns: [
                {
                    prop: "",
                    label: "操作",
                    renderFunction: (h, scope, enumData) => {
                        return h(
                            "div",
                            {
                                style: {
                                    "text-align": "center"
                                }
                            },
                            [
                                h(
                                    "el-button",
                                    {
                                        props: {
                                            type: "primary",
                                            plain: true
                                        },
                                        on: {
                                            click: () => {
                                                this.transferData(scope.row);
                                            }
                                        }
                                    },
                                    "交易明細核對"
                                )
                            ]
                        );
                    },
                    width: "150"
                },
                {
                    label: "社員姓名",
                    prop: "memberName"
                },
                {
                    label: "匯款日期",
                    prop: "transferDate",
                    renderFunction(h, scope) {
                        return h(
                            "div",
                            scope.row.transferDate
                                ? scope.row.transferDate.split(" ")[0]
                                : ""
                        );
                    }
                },
                {
                    label: "匯款帳號後五碼",
                    prop: "transferAccountNumber"
                },
                {
                    label: "銀行帳戶",
                    prop: "coopBankId",
                    renderFunction(h, scope, enumData) {
                        let result = "";
                        enumData.bank.forEach(element => {
                            if (scope.row.coopBankId == element.id) {
                                result = `${element.bankCode} ${element.bankName}`;
                            }
                        });
                        return h("div", result);
                    }
                },
                {
                    label: "匯款金額",
                    prop: "transferAmount",
                    addcomma: true
                },
                {
                    label: "傳票開立狀態",
                    prop: "voucherStatus",
                    renderFunction(h, scope) {
                        return h(
                            "div",
                            scope.row.voucherStatus ? "已開立" : "未開立"
                        );
                    }
                },
                {
                    prop: "updateTime",
                    label: "最後更新"
                },
                {
                    prop: "updateUserName",
                    label: "操作人員"
                }
            ]
        };
    },
    created() {
        this.getData();
    },
    watch: {
        voucherStatusSelect: {
            handler() {
                if (this.voucherStatusSelect === "") {
                    delete this.filter.voucherStatus;
                } else {
                    this.filter.voucherStatus = this.voucherStatusSelect;
                }
                this.$refs.workbench.getData();
            }
        },

        $route() {
            this.getData();
        }
    },
    methods: {
        openMember() {
            this.dialogMember = true;
        },
        clickMember(memberId, row) {
            this.chooseMember = row;
            this.chooseMember.showLabel = `${row.account || ""} ${row.name}`;
            this.query.memberId = memberId;
            this.dialogMember = false;
        },
        cleanMember(){
            this.query =  { memberId: this.$route.params.id };
            this.chooseMember = {};
        },
        getData() {
            if (this.id == null) return;

            const vm = this;
            const url = API.counterWork + `?id=${this.id}&action=getMemberData`;
            const thenCB = json => {
                // console.log(json.resultData[0]);
                this.dataArr = json.resultData.memberInfo.member;
            };

            this.mAxiosGet(url, thenCB);
        },
        go(name) {
            this.$router.push({ name: name });
        },
        transferVoucher() {
            if (this.$refs.workbench.multipleSelection.length <= 0) {
                this.$message({
                    message: "請先選擇要開立轉帳的傳票",
                    type: "warning",
                    duration: 5000
                });
                return;
            }

            // 本頁有兩個入口：社員搜尋(路徑帶 :id)與臨櫃作業(不帶)，
            // 兩邊的子路由名稱不同，選錯就會掉出社員情境（詳見 router.js cabinet_transfer）
            const memberId = this.$route.params.id;
            const subId = this.$refs.workbench.multipleSelection[0].id;

            this.$router.push(
                memberId == null
                    ? { name: "cabinet_transfer_summons", params: { subId } }
                    : {
                        name: "cabinet_member_transfer_summons",
                        params: { id: memberId, subId }
                    }
            );
        },
        editData(id, row) {
            // edit
            this.currentEdit = { transferAmount: 0 };

            if (id !== "new") {
                this.currentEdit = Object.assign({}, this.currentEdit, row);
            }

            setTimeout(() => {
                $(".transferDate").datepicker({
                    changeYear: true,
                    changeMonth: true,
                    currentText: "今天",
                    dateFormat: "Rmmdd",
                    showButtonPanel: true,
                    yearRange: "1912:c+10"
                });

                // 新增時 workbench 的 addData 只帶 "new"，沒有 row
                if (id === "new") {
                    this.$refs.listForm.chooseMember["memberId"].showLabel = "";
                    $(".transferDate").val("");
                    return;
                }

                this.currentEdit.transferAmount = this.$addcomma(
                    row.transferAmount
                );
                this.$refs.listForm.chooseMember[
                    "memberId"
                ].showLabel = `${row.memberAccount || ""} ${row.memberName}`;
                $(".transferDate").val(`${row.transferDate.split(" ")[0]}`);
            }, 1);
            this.dialogAddItem = true;
        },
        transferData(row) {
            // 同 transferVoucher：依入口(是否帶 :id)選對應的那組子路由
            const memberId = this.$route.params.id;

            this.$router.push(
                memberId == null
                    ? {
                        name: "cabinet_transfer_detail",
                        params: { subId: row.id, dataArr: this.dataArr }
                    }
                    : {
                        name: "cabinet_member_transfer_detail",
                        params: { id: memberId, subId: row.id, dataArr: this.dataArr }
                    }
            );
        },
        closeEdit() {
            this.dialogAddItem = false;

            this.$refs.listForm.chooseMember["memberId"] = {};
            $(".transferDate").val("");
        },
        saveData() {
            let transferDate =
                parseInt(
                    $(`.transferDate`)
                        .val()
                        .split("-")[0]
                ) +
                1911 +
                $(`.transferDate`)
                    .val()
                    .slice(3);
            var url = API.memberTransferMemo;
            const form = new FormData();
            const object = this.currentEdit;

            if (this.currentEdit.id) {
                url += `?action=update`;
            } else {
                url += `?action=append`;
            }

            Object.keys(object).map(function(objectKey, index) {
                let value = object[objectKey];
                let newValue = value.toString().replace(/,/g, "");
                if (objectKey != "transferDate" && objectKey != "memberId") {
                    form.append(
                        objectKey,
                        newValue !== undefined ? newValue : ""
                    );
                }
            });

            let memberId = this.id == null ? object.memberId : this.id;

            form.append("transferDate", transferDate);
            form.append("memberId", memberId);
            let thenCB = json => {
                this.showAjaxSuccessMsg();
                this.$refs.workbench.getData();
                this.closeEdit();
            };
            this.mAxiosPost(url, form, thenCB);
        },
        getEnumData(data) {
            this.formType[2].options = data.bank.map(item => {
                return { label: item.bankName, value: item.id };
            });
        },
        search() {
            if (!$(`.startDate`).val()) {
                this.$message.closeAll();
                this.$message({
                    type: "error",
                    message: "尚未選擇起始日期",
                    duration: 5000
                });
                return;
            }
            if (!$(`.endDate`).val()) {
                this.$message.closeAll();
                this.$message({
                    type: "error",
                    message: "尚未選擇結束日期",
                    duration: 5000
                });
                return;
            }

            let startDate =
                parseInt(
                    $(`.startDate`)
                        .val()
                        .split("-")[0]
                ) +
                1911 +
                $(`.startDate`)
                    .val()
                    .slice(3);
            let endDate =
                parseInt(
                    $(`.endDate`)
                        .val()
                        .split("-")[0]
                ) +
                1911 +
                $(`.endDate`)
                    .val()
                    .slice(3);
            this.filter = {
                ...this.filter,
                startDate,
                endDate
            };
        }
    }
};
</script>
<style lang="scss" scoped>
.w220 {
    width: 220px;
}
.inline-block {
    display: inline-block;
}

.block-content {
    .box-card {
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }

        .table {
            td {
                vertical-align: middle;
            }
        }
    }
}
</style>